module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Mos Accessories.d5676b62.webp";